export default class DataHelpers {

    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static mergeIn(dest, source, fieldNames, emptyOnly) {
        dest = { ...dest };
        if (!fieldNames) {
            fieldNames = [];
            for (var prop in source) {
                if (source.hasOwnProperty(prop)) {
                    fieldNames.push(prop);
                }
            }
        }
        for (var i = 0; i < fieldNames.length; i++) {
            const fieldName = fieldNames[i];
            if ((!dest[fieldName] && source[fieldName]) || !emptyOnly) {
                dest[fieldName] = source[fieldName];
            }
        }
        return dest;
    }

    static groupBy(list, fnGetKey) {
        const results = {};
        list.forEach(item => {
            const key = fnGetKey(item);
            if (!results[key]) {
                results[key] = [];
            }
            results[key].push(item);
        });
        return results;
    }

    static isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }

    static findLastIndex(array, predicate) {
        let l = array.length;
        while (l--) {
            if (predicate(array[l], l, array))
                return l;
        }
        return -1;
    }

    // https://stackoverflow.com/questions/36721830/convert-hsl-to-rgb-and-hex
    static hslToHex(h, s, l) {
        l /= 100;
        const a = s * Math.min(l, 1 - l) / 100;
        const f = n => {
            const k = (n + h / 30) % 12;
            const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            return Math.round(255 * color).toString(16).padStart(2, '0'); 
        };
        return `#${f(0)}${f(8)}${f(4)}`;
    }
}